// extracted by mini-css-extract-plugin
export default {"commentListContainer":"CommentsList_commentListContainer__I9ou0","commentsList":"CommentsList_commentsList__BAhQQ"};